module.exports = __webpack_public_path__ + "static/media/slack.8ed77180.png";